import DocumentsSliderPresenter from "./slider.js";

import SectionView from "../view/section.js";

export default class Documents {
  constructor(sectionElement) {
    this._sectionElement = sectionElement;

    this._documentSliders = [];

    this._sectionView = null;
  }

  init() {
    this._sectionView = new SectionView(this._sectionElement);

    this._initSliders();
  }

  _initSliders() {
    const slidersWrapper = this._sectionView.getSlidersWrappers();

    Array.from(slidersWrapper)
      .forEach((item, index) => {
        const presenter = new DocumentsSliderPresenter(item, index);
        presenter.init();

        this._documentSliders.push(presenter);
      });
  }
}
